import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Pagination from 'components/Libs/Pagination';
import styles from 'styles';
import { TextField, Table, TableBody, TableHeaderColumn, TableRow, TableRowColumn, TableHeader } from 'material-ui';
import helpers from "helpers";

class InfoRequests extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            requests: props.requests,
            search: '',
        };

        this.onSearch = this.onSearch.bind(this);
        this.handleUpdateRow = this.handleUpdateRow.bind(this);
    }

    componentDidMount() {
        this.setState({
            total: this.props.requests.length,
            requests: helpers.filterSearch(this.props.requests, this.state.search, ['mailId', 'type']),
            page: 1,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            total: props.requests.length,
            requests: helpers.filterSearch(props.requests, this.state.search, ['mailId', 'type']),
            page: 1,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.requests.slice(from, to);
    }

    onSearch(e, value) {
        this.setState({
            search: value,
            total: this.props.requests.length,
            requests: helpers.filterSearch(this.props.requests, value, ['mailId', 'type']),
            page: 1,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    handleUpdateRow(state) {
        const cloneState = _.cloneDeep(state);

        this.setState({
            ...cloneState,
            rows: this.changeRowsByPagination(cloneState),
        });
    }

    render() {
        const { search, requests, rows, rowsPerPage,numberOfRows, page } = this.state;

        return (
            <div className='paper-block margin-10'>
                <span className='name-block absolute'>Requests</span>

                <div className='row'>
                    <div className='col-xs-6'>
                        <TextField
                            value={search}
                            floatingLabelText='Search'
                            onChange={this.onSearch}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <Pagination
                            total={requests.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            numberOfRows={numberOfRows}
                            updateRows={this.handleUpdateRow}
                        />
                    </div>
                </div>
                <div className='paper-block margin-10'>
                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    date
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    eh
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    error
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    mailId
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    status
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    type
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {
                                rows.map((request, index) => {
                                    return  <TableRow key={index}>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            {moment(request.date).format('DD.MM.YYYY HH.mm.ss')}
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            {request.eh}
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            {request.error ? request.error.messages[0] : ''}
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            <a target='_blank' href={`/${request.mailId}`}>{ request.mailId }</a>
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            {request.status}
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            {request.type}
                                        </TableRowColumn>

                                    </TableRow>
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>

        );
    }
}

export default connect(
    (state, { requests }) => {
        return {
            requests,
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(InfoRequests);



// WEBPACK FOOTER //
// ./app/components/Statistics/St/Info/Requests.jsx